import { cn } from 'src/lib/utils';
import logo from 'src/images/logo.svg';

const sizes = {
  sm: 'h-8 w-8 p-1.5',
  md: 'h-9 w-[4.5rem] p-2',
  lg: 'h-12 w-28 p-2.5'
};

export default function Logo({
  size = 'md',
  className,
  alt = 'IZYA'
}) {
  return (
    <div
      className={cn(
        'box-border shrink-0 overflow-hidden rounded-lg bg-primary',
        sizes[size] || sizes.md,
        className
      )}
    >
      <img
        src={logo}
        alt={alt}
        className="block h-full w-full object-contain object-center"
      />
    </div>
  );
}
